
























































































































import { mapGetters, mapActions, mapMutations } from "vuex";

import Header from "@/layout/Header.vue";
import Footer from "@/layout/Footer.vue";

import { General, App, Home } from "@/utils/constants";
import MediaShareBar from "@/components/MediaShareBar";

export default {
  name: "DocumentValidate",
  components: {
    Header,
    Footer,
    MediaShareBar
  },
  props: {
    hash: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      General,
      App,
      Home,
      isValid: false,
      code: "",
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      validDocument: "getValidDocument",
      isContrast: "isContrast"
    }),

    maskCode() {
      return "NNNN-NNNN-NNNN-NNNN";
    },

    currentUrl() {
      return window.location.href;
    }
  },

  beforeMount() {
    if (this.hash) this.validate(this.hash);
  },

  beforeDestroy() {
    this.setValidFile({});
  },

  methods: {
    ...mapMutations({ setValidFile: "setValidFile" }),
    ...mapActions({ validateDocument: "validateDocument" }),

    submitClick(event: Event) {
      event.preventDefault();
      this.validate(this.code);
    },

    async validate(hash: string) {
      this.isLoading = true;
      await this.validateDocument(hash);
      this.isLoading = false;

      if (this.validDocument.id) this.isValid = true;
    }
  }
};
